import { useCombinedQueryStatus } from "../../core/queryHelpers";
import { RequireAuth, UserRole } from 'legoland-sdk/dist/experimental';
import { useEffectiveLimitsQuery, useSharedLimitsQuery } from "../api/limitsApiHooks";
import { useState } from 'react';
import styled from 'styled-components';
import { Box, Button, Label, Text, tombac, useTombac } from 'tombac';
import { DeleteIcon, EditIcon } from 'tombac-icons';
import { useUserDetails } from "../../users/UserDetailsProvider";
import { DeleteSharedLimitsModal } from "./DeleteSharedLimitsModal";
import { LimitSummaryList } from "./LimitSummaryList";
import { sharedLimitSchemas } from "./sharedLimitSchemas";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SharedLimitsButton = styled(Button).withConfig({
  displayName: "SharedLimitsSummary__SharedLimitsButton"
})(["background-color:", ";"], tombac.color('neutral', 400));
export const SharedLimitsSummary = _ref => {
  let {
    onRequestEditOpen
  } = _ref;
  const tombac = useTombac();
  const limitsQuery = useSharedLimitsQuery();
  const limits = limitsQuery.data?.limits;
  const [isRemoveOpen, setIsRemoveOpen] = useState(false);
  const user = useUserDetails();
  const hasUserContracts = user.contracts.length > 0;
  const odEffectiveLimitsQuery = useEffectiveLimitsQuery({
    username: user.email,
    productId: 'od'
  });
  const tsEffectiveLimitsQuery = useEffectiveLimitsQuery({
    username: user.email,
    productId: 'ts'
  });
  const combinedStatus = useCombinedQueryStatus(limitsQuery, odEffectiveLimitsQuery, tsEffectiveLimitsQuery);
  const usages = {
    ...odEffectiveLimitsQuery.data?.result.usage,
    ...tsEffectiveLimitsQuery.data?.result.usage
  };
  return /*#__PURE__*/_jsxs(Box, {
    $backgroundColor: "--neutral-400",
    $display: "grid",
    $gap: "20u",
    $gridTemplateColumns: "96u 1fr max-content",
    $mb: "5sp",
    $p: "2sp",
    "data-sentry-element": "Box",
    "data-sentry-component": "SharedLimitsSummary",
    "data-sentry-source-file": "SharedLimitsSummary.tsx",
    children: [/*#__PURE__*/_jsx(Label, {
      as: "div",
      $mt: "4u",
      "data-sentry-element": "Label",
      "data-sentry-source-file": "SharedLimitsSummary.tsx",
      "data-sentry-element": "Label",
      children: "Shared limits"
    }), combinedStatus.isError && /*#__PURE__*/_jsx(Text, {
      $mt: "0.2em",
      as: "span",
      variant: "danger",
      children: "Error: Could not load data."
    }), combinedStatus.isLoading && /*#__PURE__*/_jsx(Text, {
      $mt: "0.2em",
      as: "span",
      variant: "secondary",
      children: "Loading..."
    }), combinedStatus.isSuccess && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(LimitSummaryList, {
        limits: limits ?? {},
        schemas: sharedLimitSchemas,
        usages: usages,
        numberOfColumns: 2
      }), /*#__PURE__*/_jsx(RequireAuth, {
        role: [UserRole.Admin, UserRole.Distributor],
        children: !hasUserContracts && !user.blockOldAccessProcess && /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(SharedLimitsButton, {
            onClick: () => onRequestEditOpen(),
            shape: "circle",
            size: "xs",
            variant: "flat",
            children: /*#__PURE__*/_jsx(EditIcon, {})
          }), limits && /*#__PURE__*/_jsx(SharedLimitsButton, {
            $ml: "0.5sp",
            onClick: () => setIsRemoveOpen(true),
            shape: "circle",
            size: "xs",
            variant: "flat",
            children: /*#__PURE__*/_jsx(DeleteIcon, {
              color: tombac.color('danger')
            })
          }), /*#__PURE__*/_jsx(DeleteSharedLimitsModal, {
            isOpen: isRemoveOpen,
            onRequestClose: () => setIsRemoveOpen(false)
          })]
        })
      })]
    })]
  });
};